import { ChevronDown } from 'lucide-react';
import { Text } from '../atoms/Typography/Text';
import { useTranslation } from '../../i18n/useTranslation';
import './VoiceExamples.css';

/** Locale keys voice.examples.items.<key>: one per kind of suggestion a note can produce. */
export const VOICE_EXAMPLE_KEYS = [
  'measurements',
  'waterChange',
  'dosing',
  'dosingChange',
  'task',
  'recurring',
  'livestock',
  'expense',
  'restock',
  'observation',
] as const;

/**
 * "What can I say?" (docs/voiceFeature.md F1): example sentences behind a native
 * <details> disclosure — closed by default so the capture sheet stays short;
 * keyboard and screen readers get the expanded state for free.
 */
export function VoiceExamples({ className }: { className?: string }) {
  const { t } = useTranslation();
  return (
    <details className={['voice-examples', className].filter(Boolean).join(' ')} data-testid="voice-examples">
      <summary className="voice-examples__summary">
        <span className="voice-examples__title">{t('voice.examples.title')}</span>
        <ChevronDown size={18} className="voice-examples__icon" aria-hidden="true" focusable="false" />
      </summary>
      <div className="voice-examples__body">
        <Text variant="caption" color="secondary">
          {t('voice.examples.intro')}
        </Text>
        <ul className="voice-examples__list">
          {VOICE_EXAMPLE_KEYS.map((key) => (
            <li key={key} className="voice-examples__item">
              <Text as="span">{t(`voice.examples.items.${key}`)}</Text>
            </li>
          ))}
        </ul>
        <Text variant="caption" color="muted">
          {t('voice.examples.note')}
        </Text>
      </div>
    </details>
  );
}

export default VoiceExamples;
